import React, { useEffect, useState } from "react";
import "../../brandStore/cards/cards.css";
import BackArrow from "../../../../assets/svg/BackArrow";
import QuizWallicon from "../../../../assets/svg/QuizWallicon";
import { useNavigate } from "react-router-dom";
import authAxios from "../../../../config/authAxios";
import MyVoucherCard from "../myVoucherCard";

const MyVouhcers = () => {
  const navigate = useNavigate()


  const [giftCard, setGiftCard] = useState([])
  const fetchCards = async (e) => {
    try {
      const response = await authAxios.get(`/users/api/myVouchers`);
      setGiftCard([...response?.data?.data])
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    window.scrollTo(0,0)
    fetchCards()
  }, [])


  return (
    <>
      <div className={"box_container"}>
        <div className={"store_box_container_top"}>
          <div onClick={() => navigate(-1)}>
            <BackArrow />
          </div>
          <QuizWallicon width={143} height={31} />
        </div>
        <div className={"store_box_container"}>
          <h3 className={"st_text1_text6"}>My Gift Cards</h3>

          <div className={"banner_sub_cards"}>
           {giftCard?.length > 0 ? giftCard?.map((e) => {
              return (<React.Fragment key={e?._id}>
                <MyVoucherCard data={e}/>
              </React.Fragment>)
            }):
            <div className={"noHistory"}><h3>No Gifts Cards Redeemed</h3></div>}

          </div>
        </div>
      </div>
    </>
  );
};

export default MyVouhcers;
